import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

const fetchNotesOfCourse = async (courseId, { page = 1, pageSize = 10, text = '' } = {}) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
    ...(text && { text })  // Only add text param if it's not empty
  });

  let url = `${getConfig().LMS_BASE_URL}/blendxapi/notes/${courseId}/?${queryParams}`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

export default fetchNotesOfCourse;